import React from 'react';
import Button, { IButton } from '@monofront/design-system/components/Button';

interface IButtonShowCountProps {
  count: number;
  size?: 'small' | 'medium' | 'large';
  onClick?: IButton['onClick'];
  ariaLabel?: string;
}

export const ButtonShowCount: React.FC<IButtonShowCountProps> = ({
  count,
  size,
  onClick,
  ariaLabel,
}) => (
  <>
    <div className="btn-show-count">
      <Button
        hasMinWidth={false}
        size={size}
        onClick={onClick}
        dataTestId="ButtonShowCount-Button-1"
        ariaLabel={ariaLabel}
      >
        {count}
      </Button>
    </div>
    <style jsx>{`
      .btn-show-count > :global(button) {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        background-color: var(--clr-primary-2);
        border-color: var(--clr-primary-2);
      }
    `}</style>
  </>
);

export default ButtonShowCount;
